export const RED = '#ff2300';
export const BLUE = '#3d37bd';
export const YELLOW = '#ffff47';
export const GREEN = '#266e1c';
export const BLACK = '#000';
export const WHITE = '#fff';

export const DARK_RED = '#ef2200';

export const LESS_BLACK = '#262626';
export const GREY_C = '#ccc';
export const GREY_E = '#eee';
export const GREY_A = '#aaa';
export const GREY_6 = '#666';
export const GREY_9 = '#999';
export const GREY_3 = '#333';



// WEBPACK FOOTER //
// ../src/client/styles/colors.js